import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        backToTableText: {
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
            color: theme.palette.primary.main,
            padding: theme.spacing(2),
        },
        longTermLeasePosition: {
            paddingBottom: theme.spacing(2),
        },
    }
})

export default useStyles
